




































import {Component, Prop, Vue} from 'vue-property-decorator'
import CardCommon from '@/components/cards/CardCommon.vue'
import ButtonCommon from '@/components/lib/ButtonCommon.vue'
import ServicePrice from '@/components/ServicePrice.vue'
import {IServiceType} from '@/entities/service-type'
import {ILink} from "@/components/lib/models";
import {IServiceTypePriceReverseOptionalData} from "@/entities";

@Component({
  components: {
    CardCommon,
    ButtonCommon,
    ServicePrice
  }
})
export default class ServiceCard extends Vue {

  @Prop() readonly data!: IServiceType
  @Prop({ default: false }) readonly withCategoryLabels?: boolean;
  @Prop({ default: false }) readonly allowLargePrices?: boolean;
  private specialsArray: string[] = [];

  mounted() {
    if (this.data.special)
      this.sortDataSpecials(this.data.special);
  }

  get largePrices(): boolean {
    return !!this.allowLargePrices && (this.data.prices.length === 1);
  }

  get link(): ILink {
    return {
      label: this.$t('links.' + this.data.type + '-short') as string,
      ref: 'Modal' + this.$options.filters?.camelCase(this.data.type)
    }
  }

  private openLink(link: ILink): void {
    // open modal with subject
    let prices = this.data.prices;
    let id = this.data.id
    let subject: IServiceTypePriceReverseOptionalData = {
      ...(prices.length === 1 ? prices[0] : {id}),
      // ...{},
      service_type: this.data
    };
    this.$storage.actions.setModal({
      name: link.ref,
      subject: subject,
      from: 'services'
    });
  }
  private linkTelegram() {
    window.open('https://t.me/bonifiquelife/');
  }
  private GetLink() {
    if (this.data.type === 'service' || this.data.type === 'plan') {
         this.linkTelegram();
    }
    else {
      this.openLink(this.link);
    }
  }
  sortDataSpecials(specialStr: string): void {
    if (specialStr.includes('\r')) {
      this.specialsArray = specialStr.split('\r');
    }
  }
}
